import styles from './Spinner.module.css'

export const SpinnerCard = () => {
  return (
    <div className={ `spinner-border ${ styles.spinnerCard }` } role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}
